import api from '../config/api';

const BASE = '/api/inventory/packaging';

export const listPackagingSkus = async (params = {}) => {
  const response = await api.get(`${BASE}/skus`, { params });
  return response.data;
};

export const createPackagingSku = async (payload) => {
  const response = await api.post(`${BASE}/skus`, payload);
  return response.data;
};

export const updatePackagingSku = async (id, payload) => {
  const response = await api.patch(`${BASE}/skus/${id}`, payload);
  return response.data;
};

export const listPackagingRules = async (params = {}) => {
  const response = await api.get(`${BASE}/rules`, { params });
  return response.data;
};

export const createPackagingRule = async (payload) => {
  const response = await api.post(`${BASE}/rules`, payload);
  return response.data;
};

export const updatePackagingRule = async (id, payload) => {
  const response = await api.put(`${BASE}/rules/${id}`, payload);
  return response.data;
};

export const deletePackagingRule = async (id, params = {}) => {
  const response = await api.delete(`${BASE}/rules/${id}`, { params });
  return response.data;
};

export const listPackagingChannels = async () => {
  const response = await api.get(`${BASE}/channels`);
  return response.data;
};

export const listPackagingWarehouses = async () => {
  const response = await api.get(`${BASE}/warehouses`);
  return response.data;
};

export const listPackagingProducts = async (params = {}) => {
  const response = await api.get(`${BASE}/products`, { params });
  return response.data;
};

export const recalculatePackagingConsumption = async (payload = {}) => {
  const response = await api.post(`${BASE}/recalculate`, payload);
  return response.data;
};
